<h2>Orte</h2>
<div class="grid">
  <div class="col-12">
    <p-table [value]="rooms" [rowTrackBy]="rowTrackBy" editMode="row" dataKey="id" #table>
      <ng-template pTemplate="header">
        <tr>
          <th>#</th>
          <th>Name</th>
          <th>Adresse</th>
          <th>Etage</th>
          <th>Raum / Treffpunkt</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-room let-index="rowIndex" let-editingRow="editing">
        <tr [pEditableRow]="room">
          <td>{{index + 1}}</td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="output">
                {{room.name}}
              </ng-template>
              <ng-template pTemplate="input">
                <input pInputText [(ngModel)]="room.name">
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="output">
                {{room.address}}
              </ng-template>
              <ng-template pTemplate="input">
                <input pInputText [(ngModel)]="room.address">
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="output">
                {{room.floor}}
              </ng-template>
              <ng-template pTemplate="input">
                <input pInputText [(ngModel)]="room.floor">
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="output">
                {{room.room}}
              </ng-template>
              <ng-template pTemplate="input">
                <input pInputText [(ngModel)]="room.room">
              </ng-template>
            </p-cellEditor>
          </td>
          <td class="actionColumn">
            @if (editingRow) {
              <p-button icon="pi pi-save" pSaveEditableRow (click)="updateRoom(room)" ariaLabel="Speichern"></p-button>
            }
            @if (editingRow) {
              <p-button icon="pi pi-times" pCancelEditableRow (click)="onRoomEditCancel(room)" ariaLabel="Abbrechen"></p-button>
            }
            @if (!editingRow) {
              <p-button icon="pi pi-pencil" pInitEditableRow (click)="onRoomEditInit(room)" [disabled]="editing" ariaLabel="Bearbeiten"></p-button>
            }
            @if (!editingRow) {
              <p-button icon="pi pi-trash" (click)="deleteRoom(room)" [disabled]="editing" ariaLabel="Löschen"></p-button>
            }
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4">Bisher keine Orte vorhanden.</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="summary">
        <div class="flex gap-2 justify-content-end align-items-center p-3">
          <p-button label="Ort hinzufügen" icon="pi pi-plus" (click)="createRoom(table)" [disabled]="editing" ariaLabel="Ort hinzufügen"></p-button>
        </div>
      </ng-template>
    </p-table>
  </div>
</div>
<p-dialog header="Fehler beim Löschen des Orts" [visible]="roomErrors != null" [closable]="false" [modal]="true">
  <edu-udo-itmc-dev-mini-book-error-renderer [errors]="roomErrors">
  </edu-udo-itmc-dev-mini-book-error-renderer>
  <ng-template pTemplate="footer">
    @if (roomInError) {
      <p-button icon="pi pi-check" (click)="clearRoomError(true)" label="Löschen erzwingen" styleClass="p-button-text" ariaLabel="Löschen erzwingen"></p-button>
    }
    <p-button (click)="clearRoomError(false)" label="Abbrechen" ariaLabel="Abbrechen"></p-button>
  </ng-template>
</p-dialog>
